interface Bgm {
  audio: HTMLAudioElement
  interval?: NodeJS.Timer
}

let bgmCurrent: Bgm
const bgms: Record<string, Bgm> = {}

const createBgm = (src: string): Bgm => {
  const audio = new Audio()
  audio.src = src
  audio.loop = true
  audio.preload = 'auto'

  const bgm = { audio }
  bgms[src] = bgm
  return bgm
}

export const loadBgm = async (src: string): Promise<void> => {
  if (!bgms[src]) {
    await new Promise<void>((resolve) => {
      const bgm = createBgm(src)
      bgm.audio.addEventListener('canplaythrough', () => {
        resolve()
      })
      bgm.audio.load()
    })
  }
}

export const playBgm = (src: string) => {
  if (!bgms[src]) {
    createBgm(src)
  }
  if (bgmCurrent && bgmCurrent !== bgms[src]) {
    bgmDown(bgmCurrent)
  }
  bgmCurrent = bgms[src]
  bgmUp(bgmCurrent)
}
export const stopBgm = () => {
  if (bgmCurrent) {
    bgmDown(bgmCurrent)
  }
}

/**
 * iOS does not support volume control
 */
const IS_IOS = /iPad|iPhone|iPod/.test(window.navigator.platform)

/* eslint no-param-reassign: 0 */

const bgmUpFadeIn = async (bgm: Bgm) => {
  try {
    await bgm.audio.play()
    clearInterval(bgm.interval)
    bgm.interval = setInterval(() => {
      if (bgm.audio.volume + 0.1 >= 1) {
        bgm.audio.volume = 1
        clearInterval(bgm.interval)
      } else {
        bgm.audio.volume += 0.1
      }
    }, 50)
  } catch (error) {
    console.error(error)
  }
}
const bgmUpOn = async (bgm: Bgm) => {
  try {
    await bgm.audio.play()
  } catch (error) {
    console.error(error)
  }
}
const bgmUp = IS_IOS ? bgmUpOn : bgmUpFadeIn

const bgmDownFadeOut = async (bgm: Bgm) => {
  clearInterval(bgm.interval)
  bgm.interval = setInterval(() => {
    if (bgm.audio.volume - 0.1 <= 0) {
      bgm.audio.pause()
      bgm.audio.volume = 0
      bgm.audio.currentTime = 0
      clearInterval(bgm.interval)
    } else {
      bgm.audio.volume -= 0.1
    }
  }, 50)
}
const bgmDownOff = async (bgm: Bgm) => {
  bgm.audio.pause()
  bgm.audio.currentTime = 0
}
const bgmDown = IS_IOS ? bgmDownOff : bgmDownFadeOut
